import { useState } from 'react'

import { HELP } from 'externalUrls'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { useStorageLanguages } from 'utils/sdks/localize'
import { accessZendeskLoggedIn } from 'utils/sdks/zendesk'
import { clearStorage } from 'utils/storage'

import { getUserId, userIsLoggedInAsAdmin } from 'store/currentUser/selectors'

import { ADMIN_LOGOUT, LOGOUT } from 'routes/paths'

import { OptionWrapper } from '../../retailerAccountsDropdown.ui'
import LanguageModal from 'features/Navbar/NavbarLiteRetailer/modals/LanguageModal/LanguageModal'
import MenuText from 'features/Navbar/NavbarRevamp/components/DropdownMenuTextLink/DropdownMenuText'
import DropdownMenuTextLink from 'features/Navbar/NavbarRevamp/components/DropdownMenuTextLink/DropdownMenuTextLink'
import { flagsMap } from 'features/Navbar/NavbarRevamp/components/LocalizeDropdown/utils'
import messages from 'features/Navbar/NavbarRevamp/constants/navbarRevamp.messages'
import { RetailAccountsDropdownIds } from 'features/Navbar/NavbarRevamp/navbarRevamp.ids'
import { useNavbarLogout } from 'features/Navbar/hooks/useNavbarLogout'

const StyledMenuText = styled(MenuText)`
  display: flex;
  align-items: center;
`

const FlagImg = styled.img`
  margin-left: 8px;
  border-radius: 50%;
`

const CommonSettings = () => {
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false)
  const userId = useSelector(getUserId)
  const isLoggedInAsAdmin = useSelector(userIsLoggedInAsAdmin)
  const handleLogout = useNavbarLogout()
  const { language } = useStorageLanguages()

  return (
    <>
      <OptionWrapper>
        <StyledMenuText
          message="Language"
          onClick={() => setIsLanguageModalOpen(true)}
          id={RetailAccountsDropdownIds.Language}
          className="language"
          badge={
            <FlagImg
              width="20px"
              height="20px"
              src={flagsMap[language.code]}
              alt={language.code}
            />
          }
        />
      </OptionWrapper>
      <OptionWrapper>
        <DropdownMenuTextLink
          to={accessZendeskLoggedIn(HELP)}
          message={messages.helpCenter}
          target="_blank"
          id={RetailAccountsDropdownIds.Help}
        />
      </OptionWrapper>
      {isLoggedInAsAdmin && (
        <OptionWrapper>
          <DropdownMenuTextLink
            to={ADMIN_LOGOUT}
            message={messages.switchToAdmin}
            onClick={() => clearStorage(`${userId}`)}
            id={RetailAccountsDropdownIds.SwitchTo}
          />
        </OptionWrapper>
      )}
      <OptionWrapper>
        <DropdownMenuTextLink
          to={LOGOUT}
          message={messages.logout}
          onClick={handleLogout}
          id={RetailAccountsDropdownIds.Logout}
        />
      </OptionWrapper>
      {isLanguageModalOpen && (
        <LanguageModal
          isOpen={isLanguageModalOpen}
          onClose={() => setIsLanguageModalOpen(false)}
        />
      )}
    </>
  )
}

export default CommonSettings
